import React from "react";

export function SingleSectionTitle(props: { section: { title?: string } }) {
  if (props.section.title === "") {
    return null;
  }
  return (
    <>
      {" - "}
      {props.section.title}
    </>
  );
}
